import { format, isToday } from "date-fns";
import { AugmentDeviceData } from "./types";

export function getLastEventStatus(device: AugmentDeviceData) {
  const lastSensorEvent = device.latest_event?.emittedByDeviceAt;

  const isHub = device.child_device_internal_id === "hub";
  const lastHubOnline = isHub && device.latest_event?.kinesisReceivedAt;

  const lastEvent = isHub ? lastHubOnline : lastSensorEvent;

  const formattedDate = lastEvent
    ? isToday(new Date(lastEvent))
      ? `Today at ${format(new Date(lastEvent), "h:mm a")}`
      : format(new Date(lastEvent), "LLLL d")
    : null;

  return {
    lastEvent: formattedDate,
  };
}
